import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import TimePicker from "./TimePicker";
import Button from "./Button";
import ActionButton from "./ActionButton";

const Controls = {
  Input,
  RadioGroup,
  Select,
  Checkbox,
  DatePicker,
  TimePicker,
  Button,
  ActionButton,
};

export default Controls;
